var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreator = void 0;
const contentful_page_preview_1 = require("@wheelroom/contentful-page-preview");
const getters_1 = require("./getters");
exports.actionCreator = (state, dispatch) => {
    const fetchPage = (adminCoreState) => {
        const pagePreviewStore = getters_1.getPreviewPageStore(adminCoreState);
        if (!pagePreviewStore) {
            return;
        }
        if (pagePreviewStore.state.isFetching) {
            return;
        }
        const pageProps = adminCoreState.pageProps;
        const entryId = pageProps.pageContext.pageContentfulId;
        const previewSecrets = pageProps.data.site.siteMetadata.secrets;
        const locale = pageProps.pageContext.locale;
        if (!pageProps.pageContext.pageContentfulId) {
            console.log('Warning: Could not find field contentful_id, is it present in the page query?');
        }
        function getPreviewPage(dispatch) {
            return __awaiter(this, void 0, void 0, function* () {
                const pagePreview = contentful_page_preview_1.createPagePreview({
                    entryId,
                    locale,
                    previewSecrets,
                    include: 10,
                    maxDepth: 8,
                });
                const fetchedPage = yield pagePreview.getGatbsyFields();
                dispatch({ type: 'SET_PREVIEW_PAGE', previewPage: fetchedPage });
                dispatch({ type: 'SET_IS_FETCHING', isFetching: false });
            });
        }
        dispatch({ type: 'SET_IS_FETCHING', isFetching: true });
        getPreviewPage(dispatch);
    };
    return {
        fetchPage,
    };
};
//# sourceMappingURL=action-creator.js.map